import React from 'react';
import QuestionManager from '../components/QuestionManager';

const AdminBuyerQuestions = () => {
  return (
    <QuestionManager 
      category="buyer" 
      title="Manage Buyer Questions"
      description="Configure questions for buyer verification"
    />
  );
};

export default AdminBuyerQuestions;
